import utils from '../utils/util';

const msgTypes = {
  successchat: "zxkf_001", /*正常回话*/
  inputing: "zxkf_002", /*客户正在输入*/
  endchat: "zxkf_004", /*结束回话*/
  automsg: "zxkf_005", /*自动回复消息*/
  systemtip: "zxkf_006", /*系统提示*/
  floatComment: "zxkf_007", /*浮动评价框*/
  popComment: "zxkf_008", /*回话评价框*/
  staffInputing: "zxkf_0021", /*客服正在输入*/
  comment: "zxkf_0061", /*发送评价消息*/
  timeout: "zxkf_009", /*第一次超时*/
  timeout1: "zxkf_0012", /**/
  joinedChannel: "zxkf_0011", /*客户进入频道回执*/
  turn: "zxkf_0010", /*转接*/
  robot: "zxkf_robot",  //  机器人回复消息
  robotfail: "zxkf_robotfail"   // 机器人回复消息失败
};

/**
 * 消息状态
 */
const msgStatus = {
  preSend: 0,        // 预发送
  sending: 1,       // 发送中
  sendSuccess: 2,   // 发送成功
  sendFail: 3       // 发送失败
}


/**
 * 用户类型
 */
const userType = {
  msgFromMe: 1,     //  自己
  msgFromRobot: 2,   // 机器人
  msgFromPeople: 3    // 客服
}

// 消息体类型
const msgShowType = {
  loading: -3,    // 加载中  接收机器人消息专用
  txtTip: -2,     // 文本提示
  timeTip: -1,     // 时间提示
  callPeopel: 0,    // 转人工
  text: 1,         // 文本消息
  img: 2,          // 图片消息
  questions: 3,
  file: 4
}

class MsgParse {
  constructor() {
    this.genMsg = new GeneratorMsg()
  }

  getRobotLoading(id) {
    return this.genMsg.getLoadingMsg(id);
  }

  dealMsg (realmsg) {
    var time = realmsg.SendDateTime * 1000;
    if (!realmsg.Extension && realmsg.Content) {
        realmsg = JSON.parse(realmsg.Content);
        realmsg.SendDateTime = time;
    }

    if (realmsg.Extension == msgTypes.endchat) {
      Bus.$emit("endchatMsg")
      return;
    }

    switch(realmsg.Extension) {
      case msgTypes.robot:
        this.decodeRobot(realmsg);
        break;
      case msgTypes.robotfail:
        this.decodeFailRobot(realmsg);
        break;
      case msgTypes.automsg:
        this.decodeAutoMsg(realmsg)
        break;
      case msgTypes.successchat:
        this.decodeNormalMsg(realmsg)
        break;
      case msgTypes.staffInputing:
        Bus.$emit("staffInputing")
        break;
      case msgTypes.popComment:
        Bus.$emit("triggerFeedActionsheet")
        break;
      case msgTypes.timeout1:
        Bus.$emit("closeHeart");
      case msgTypes.timeout:
        Bus.$emit("timeout", realmsg.Content);
        break;
      case msgTypes.endchat:
        Bus.$emit("triggerFeedActionsheet", ()=>{}, true)
        break;
      default:
        break;

    }
  }

  /**
   * 文本提示
   * @param {Int} btnType 0: 带排队取消按钮  1：接通，工号标红 2: 排队人数过多，可直接跳转反馈
   */
  getTxtTip (msg, btnType) {
    var match = /您前面还有(\d+)位客户正在等待服务，请稍后~/.exec(msg);
    if (match && +match[1] >= configs["maxNum"]) {   // 排队人数大于等于50时，显示人数过多文字信息，同时能够留言反馈
      btnType = 2;
    }
    return this.genMsg.genTxtTip(msg, btnType);
  }
  /**
   * 自动回复消息
   */
  decodeAutoMsg (msg) { Bus.$emit("autoMsg", this.genMsg.getAutoMsg(msg)); }

  decodeNormalMsg(msg) {
    var _data = this.genMsg.getNormalMsg(msg)
    $historyStorage.push(Object.assign({}, msg, {Type: 2, SendDateTime: new Date().getTime()}))
    Bus.$emit("normalMsg", _data)
  }

  // 显示客户端模板消息
  showClientTplMsg(type, uType) { Bus.$emit("robotSay", this.genMsg.getClientGentorMsg(type, uType)) }

  welcomeMsg(questions) {
    Bus.$emit("robotSay", this.genMsg.getClientGentorMsg("welcomeMsg"))
    if (questions && questions.length > 0) {
      Bus.$emit("robotSay", this.genMsg.getQuestions(questions))
    }
  }

  getQuestions(questions, id, tipTxt, txt, showRefresh){
    return  this.genMsg.getQuestions(questions, id, tipTxt, txt, showRefresh)
  }

  decodeFailRobot(msg) {
    var json = null;
    try {
      json = JSON.parse(msg.Content);
    }catch(err) {
      json = msg.Content;
    }
    json.SendDateTime = msg.SendDateTime
    var _data = this.genMsg.getFailRobot(json, "robotFail");
    Bus.$emit("robotSay", _data);
    $historyStorage.push(Object.assign({}, msg, {Type: 7, SendDateTime: new Date().getTime()}))
    Bus.$emit("robotSay", this.genMsg.callPeople(json, "robotFailCall"));
  }

  callPeople(str) {
    Bus.$emit("robotSay", this.genMsg.callPeople(new Date().getTime(), str));
  }

  dealHistoryMsg(msg) {
    var msgList = []
    for(var i = msg.length - 1; i >=0  ; i--) {
      var realmsg = null
      try {
        msg[i].MessageContent = msg[i].MessageContent ||　msg[i].Content
        if (msg[i].MessageContent.indexOf("{") == -1) {
          throw "";
        }
        realmsg = JSON.parse(msg[i].MessageContent);
      }catch(e){
        realmsg = {
          Content: msg[i].MessageContent
        }
      }
      // 奇葩的时间格式 "/Date(1523240801203)/"   兼容以前暂不修改
      realmsg.SendDateTime = msg[i].SendDateTime || msg[i].SendTime.split("/Date(")[1].split(")/")[0];

      var msgObj = null;
      // 2 客服  7机器人  9 用户
      switch(msg[i].Type) {
        case 1:
        case 2:
          msgObj = this.genMsg.getNormalMsg(realmsg);
          break;
        case 7:
          if (realmsg.Data && realmsg.Data.Answer) {
            msgObj = this.genMsg.robotSay(realmsg);
          } else {
            msgObj = this.genMsg.getFailRobot(realmsg, "robotFail");
          }
          break;
        case 9:
          msgObj = this.genMsg.getHisotryMsg(realmsg)
          break;
        default:
          logger(msg[i]);
      }
      if (msgObj) {
        msgObj.feedbackObj = '';
        msgList.push(msgObj)
      }
    }
    Bus.$emit("showHistoryMsg", msgList);
  }

  /**
   * 处理用户发送的消息
   * @param {any} msg
   * @param {int} type  1：图片  其他： 文字
   * @memberof MsgParse
   */
  dealSendMsg (msg, type) {
    var _msg = {};
    if (type == 1) {
      _msg = this.genMsg.getSendImgMsg(msg);
    } else {
      _msg = this.genMsg.dealSendMsg(msg);
    }
    return _msg
  }

  /**
   * 解析机器人消息
   */
  decodeRobot(_content) {
    var json = null;
    try {
      json = JSON.parse(_content.Content);
    }catch(err) {
      json = _content.Content || _content;
    }

    json.SendDateTime = _content.SendDateTime
    switch (json.Code) {
      case "1002":  // 机器人没有匹配答案
        Bus.$emit("robotSay", this.genMsg.getFailRobot("robotNoMatch",json));
        Bus.$emit("robotSay", this.genMsg.callPeople(json));
        break;
      case "1000":
          var _data = this.genMsg.robotSay(json, "1000");
          Bus.$emit("robotSay", _data);
          $historyStorage.push(Object.assign({}, _content, {Type: 7, SendDateTime: new Date().getTime()}))
          Bus.$emit("blurryQuestions", json.Data && json.Data.BlurryQuestions);
        break;
      case "1001":
        var _data = this.genMsg.robotSay(json, "1001");
        Bus.$emit("robotSay", _data);
        $historyStorage.push(Object.assign({}, _content, {Type: 7, SendDateTime: new Date().getTime()}))
        Bus.$emit("blurryQuestions", json.Data && json.Data.BlurryQuestions);
        // Bus.$emit("robotMath", json.data, json.userQuestionId);
        break;
      case "1003":
        setTimeout(() => {
          Bus.$emit("removeMsg", json.UserQuestionId);
          Bus.$emit("updateTxtTip", json.Data.Answer.Answer);
        }, 30);
        setTimeout(() => {
          Bus.$emit("toCustomer");
        }, 60);
        break;
      case "500":
        Bus.$emit("robotError");
        break;
      default:
        break;
    }
  }

  /**
   * 需要发送的消息体
   * @param {*} _msg
   * @param {*} _type    200:  不入库
   */
  parseToSendMsg(_msg, _type) {
    var data = {}
    _type = _type || msgTypes.successchat;

    var ct = 0;
    if (_type == msgTypes.inputing) {
        ct = 200;
        return;
    }

    var data = { "Extension": _type, "Content": utils.htmlDecode(_msg) };

    data["msg"] = JSON.stringify(data);
    data["ct"] = ct;

    return data;
  }
}

  /*
   * 消息体
   * msgid 消息id  getMsgID生成自增（用于v-for 中的 key）
   * id   消息id   消息来自服务端时，为服务端消息id，否则客户端自行生成（）
   * content      消息内容
   * msgStatus    消息状态  1: 发送中/加载中   2：发送成功（客户发送有效）   3. 发送失败（客户发送有效）
   * msgType      消息类型  -2: 文本提示 -1: 时间提示   0: 转人工 1: 文本  2： 图片
   * userType     消息是否为自己发送  1: 自己/客户 消息   2. 机器人消息  3: 客服消息
   * sendTime     消息发送时间
   * showSendTime 是否展示发送时间，为空或false时不显示
   * */
var robotSayIndex = 0;
var msgid = new Date().getTime();
class GeneratorMsg {
  constructor(){
    this.startTime = 0
    this.endTime = 0
  }


  getMsgID() {
    return msgid++;
  }

  getHisotryMsg(msg) {
    var id = id || this.getMsgID();
    var msgType = utils.getMsgType(msg.Content, id)
    return {
      msgid: id,
      id: `history_${id}`,
      content: msgType || utils.transferUrlToImg(msg.Content, id),
      msgStatus: msgStatus.sendSuccess,
      msgType: !!msgType ? msgShowType.file : msgShowType.text,
      userType: msg.Sender == null || msg.Sender.length >= 16 ? userType.msgFromMe : userType.msgFromPeople,
      sendTime: msg.SendDateTime,
      showSendTime: this.showSendTime(msg.SendDateTime, -1)
    }
  }

  getQuestions(questions, id, tipTxt, txt, showRefresh) {
    var id = id || this.getMsgID();
    var sendDateTime = new Date().getTime();

    return {
      msgid: id,
      id: `questions_${id}`,
      content: {
        txt: txt || '',
        tipTxt: tipTxt || '',
        showRefresh: showRefresh !== void 0 ? showRefresh : !!id,
        questions: questions
      },
      msgStatus: msgStatus.sendSuccess,
      msgType: msgShowType.questions,
      sendTime: sendDateTime,
      userType: userType.msgFromRobot,
      showSendTime: this.showSendTime(sendDateTime)
    }
  }

  // 图片消息
  getSendImgMsg(msg) {
    var id = this.getMsgID();
    var sendDateTime = new Date().getTime();
    return {
      msgid: id,
      id: `img_${id}`,
      fileName: msg.name || '',
      content: msg.msg,
      msgStatus: msgStatus.preSend,
      msgType: msgShowType.img,
      sendTime: sendDateTime,
      userType: userType.msgFromMe,
      showSendTime: this.showSendTime(sendDateTime)
    }
  }

  getAutoMsg (msg) {
    var id = this.getMsgID();
    return {
      msgid: id,
      id: `autoMsg_${id}`,
      content: msg.Content,
      msgType: msgShowType.text,
      sendTime: msg.SendDateTime,
      userType: userType.msgFromPeople,
      showSendTime: this.showSendTime(new Date().getTime())
    }
  }

  /**
   * 客户端生成的消息，只需传入type， 对应config.js文件中的文字
   */
  getClientGentorMsg(type, uType) {
    var id = this.getMsgID();
    var time = new Date().getTime();
    return {
      msgid: id,
      id: `autoMsg_${id}`,
      content: window.configs[type] || type,
      msgType: msgShowType.text,
      sendTime: time,
      userType: userType[uType] || userType.msgFromRobot,
      showSendTime: this.showSendTime(time)
    }
  }

  getNormalMsg (msg) {
    var id = this.getMsgID()
    var msgType = utils.getMsgType(msg.Content, id)
    return {
      msgid: id,
      id: msg.ID,
      content: msgType || utils.transferUrlToImg(msg.Content, id),
      msgType: !!msgType ? msgShowType.file : msgShowType.text,
      sendTime: msg.SendDateTime,
      userType: userType.msgFromPeople,
      showSendTime: this.showSendTime(msg.SendDateTime)
    }
  }

  genTxtTip(msg, btnType) {
    var sendTime = new Date().getTime();
    return {
      msgid: this.getMsgID(),
      id: "lineup",
      content: msg,
      msgType: msgShowType.txtTip,
      sendTime: sendTime,
      btnType: btnType || 0,
      showSendTime: this.showSendTime(sendTime)
    }
  }

  dealSendMsg(msg) {
    var msgid = this.getMsgID();

    return {
      msgid: msgid,
      id: `client_${msgid}`,
      content: msg.QuestionContent || msg,
      SmallTypeId: msg.SmallTypeId || '',
      msgStatus: msgStatus.preSend,
      userType: userType.msgFromMe,
      sendTime: new Date().getTime(),
      msgType: msgShowType.text,
      showSendTime: this.showSendTime(new Date().getTime())
    }
  }

  showSendTime(sendDateTime, type) {
    if (!sendDateTime) { return false;}
    try {
      sendDateTime = +sendDateTime
    } catch(e) {
      logger("sendDateTime 类型转换错误:", sendDateTime)
    }
    if (this.startTime == 0 && this.endTime == 0) {
      this.startTime = sendDateTime
      this.endTime = sendDateTime
      return true
    }

    if (type == -1) {     // 历史记录时间判断
      if (this.startTime - sendDateTime >= 30 * 60 * 1000) {
        this.startTime = sendDateTime
        return true
      }
      return false;
    }

    if (this.startTime - sendDateTime >= 30 * 60 * 1000) {
      this.startTime = sendDateTime
      return true
    }
    if (this.endTime - sendDateTime >= 30 * 60 * 1000 ) {
      this.endTime = sendDateTime
      return true
    }
    return false;
  }

    // 机器人消息
  getFailRobot(json, type) {
      var data = json.Data
      return {
        msgid: this.getMsgID(),
        id: json.QId,
        content: window.configs[type],
        msgStatus: msgStatus.sendSuccess,
        userType: userType.msgFromRobot,
        sendTime: json.SendDateTime,
        msgType: msgShowType.text,
        showSendTime: this.showSendTime(json.SendDateTime)
      }
  }

  // 机器人普通消息
  robotSay(json,type) {
    var data = json.Data
    var canFeedback = data.Answer.CanFeedback
    var hasAnswer = data.RelateAnswers && data.RelateAnswers.length > 0;
    var answers  = hasAnswer ? data.RelateAnswers : data.BlurryQuestions
    return {
      msgid: this.getMsgID(),
      id: json.UserQuestionId,
      content: data.Answer.Answer,
      feedbackObj: canFeedback ? this.getFeedbackObj(json): '',
      tipTxt: hasAnswer ? '您是不是还想问？':'您是不是想问？',
      relateAnswers: answers,
      msgStatus: msgStatus.sendSuccess,
      userType: userType.msgFromRobot,
      sendTime: json.SendDateTime,
      msgType: msgShowType.text,
      showSendTime: this.showSendTime(data.SendDateTime),
      Basequestion: type == "1001" ? json.UserQuestion : "",
      Questiontype: type == "1001" ? 1 : 0
    }
  }

  // 转接人工消息
  callPeople(json, str) {
    var msgid = this.getMsgID();
    return {
      msgid: msgid,
      id: `callPeople`,
      content: window.configs[str] || str || "",
      msgStatus: msgStatus.sendSuccess,
      userType: userType.msgFromRobot,
      sendTime: json.SendDateTime || json,
      msgType: msgShowType.callPeopel,
      showSendTime: this.showSendTime(json.SendDateTime || json)
    }
  }

  getLoadingMsg(id) {
    var sendTime = new Date().getTime();
    msgid++
    return {
      msgid: this.getMsgID(),
      id: id,
      content: "正在加载...",
      msgStatus: msgStatus.sendSuccess,
      userType: userType.msgFromRobot,
      sendTime: sendTime,
      msgType: msgShowType.loading,
      showSendTime: this.showSendTime(sendTime)
    }
  }

  getFeedbackObj(obj){
    return {
      AnswerId: obj.Data.Answer.Aid,
      SmallTypeId: obj.Data.Answer.SmallTypeId || '',
      QuestionId: obj.UserQuestionId,
      QuestionContent: obj.UserQuestion
    }
  }
}


export default new MsgParse();



// WEBPACK FOOTER //
// ./src/store/msgParse.js